import { useGetUser, useUpdateUser } from '../../hooks/api-hooks';
import { Switch } from '@headlessui/react';
import { useState } from 'react';
import { classNames } from '../../utils';
import { queryClient } from '../../app';

export default function Notifications() {
  const user = useGetUser();
  const userMutation = useUpdateUser();
  const [enabled, setEnabled] = useState(user.data?.notifyOnSwapComplete || false);
  const [isSaving, setIsSaving] = useState(false);

  const handleNotificationToggle = async () => {
    setIsSaving(true);

    try {
      const response = await userMutation.mutateAsync({
        updateUserBody: { notifyOnSwapComplete: !enabled },
      });

      if (user.data) {
        queryClient.setQueryData(['getUser'], {
          ...user.data,
          notifyOnSwapComplete: response.notifyOnSwapComplete,
        });
      }

      setEnabled(!enabled);
    } catch (error) {
      console.error('Error updating user notification settings:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="divide-y divide-gray-200">
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 py-16 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base font-semibold leading-7 text-gray-900">Notification Settings</h2>
        </div>

        <form className="md:col-span-2">
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
            <Switch.Group as="div" className="flex items-center justify-between col-span-full">
              <span className="flex flex-grow flex-col">
                <Switch.Label as="span" className="text-sm font-medium leading-6 text-gray-900" passive>
                  Notify me when a video Swap is complete
                </Switch.Label>
                <Switch.Description as="span" className="text-sm text-gray-500">
                  Receive a notification via email when a video Swap you initiated has finished processing.
                </Switch.Description>
              </span>
              <Switch
                checked={enabled}
                onChange={handleNotificationToggle}
                className={classNames(
                  enabled ? 'bg-indigo-600' : 'bg-gray-200',
                  'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2',
                  isSaving ? 'opacity-50 cursor-not-allowed' : ''
                )}
                disabled={isSaving}
              >
                <span
                  aria-hidden="true"
                  className={classNames(
                    enabled ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                  )}
                />
              </Switch>
            </Switch.Group>
          </div>
        </form>
      </div>
    </div>
  );
}